(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-gallery]');
  if (!root) return;
  var track = root.querySelector('[data-gallery-track]');
  if (!track) return;

  var mqDesktop = window.matchMedia('(min-width: 768px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  var pinned = false;
  var maxShift = 0;
  var ticking = false;

  function update() {
    ticking = false;
    var total = root.offsetHeight - window.innerHeight;
    if (total <= 0) return;
    var progress = Math.min(1, Math.max(0, -root.getBoundingClientRect().top / total));
    track.style.transform = 'translate3d(' + (-progress * maxShift).toFixed(2) + 'px, 0, 0)';
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  function enable() {
    pinned = true;
    root.classList.add('editorial-gallery--pinned');
    root.style.height = (window.innerHeight + maxShift) + 'px';
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  function disable() {
    pinned = false;
    root.classList.remove('editorial-gallery--pinned');
    root.style.height = '';
    track.style.transform = '';
    window.removeEventListener('scroll', onScroll);
  }

  function evaluate() {
    /* Pin + horizontal-scroll on all sizes (incl. mobile); only motion
       preference opts out. */
    var canPin = !mqReduce.matches;
    if (canPin) {
      var shift = track.scrollWidth - window.innerWidth;
      if (shift > 0) {
        maxShift = shift;
        if (pinned) {
          root.style.height = (window.innerHeight + maxShift) + 'px';
          update();
        } else {
          enable();
        }
        return;
      }
    }
    if (pinned) disable();
  }

  var resizeTimer;
  var lastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    /* Ignore height-only changes (mobile URL bar show/hide during scroll),
       which would otherwise recompute the pin height and cause a jump. */
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(evaluate, 150);
  }, { passive: true });

  if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', evaluate);
  if (mqReduce.addEventListener) mqReduce.addEventListener('change', evaluate);

  evaluate();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var hero = document.querySelector('.editorial-hero');
  if (!hero) return;
  var imgs = hero.querySelectorAll('.editorial-hero__image');
  if (!imgs.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* The bottom caption is pinned near the viewport bottom, so the shared
     scroll-reveal observer (with its -33% bottom dead zone) only fires it
     once the hero releases — too late. Reveal it on early hero scroll. */
  var caption = hero.querySelector('.editorial-hero__group--bottom');
  var captionShown = false;

  /* Continuous rAF loop with easing (lerp): the transform is updated every
     frame and glides toward its target, so motion stays smooth on mobile where
     scroll events fire coarsely (which caused the stutter). */
  var current = 0, target = 0, running = false, inView = true;

  function computeTarget() {
    var rect = hero.getBoundingClientRect();
    var heroHeight = hero.offsetHeight;
    var progress = -rect.top / heroHeight;
    if (progress < 0) progress = 0;     /* no downward shift at the top (avoids a gap) */
    if (progress > 1) progress = 1;
    var depth = window.innerWidth >= 768 ? 0.45 : 0.22;   /* matches image overflow (150%/125%) */
    target = -progress * heroHeight * depth;
    inView = !(rect.bottom < -80 || rect.top > window.innerHeight + 80);

    if (caption && !captionShown && progress > 0.06) {
      caption.classList.add('is-revealed');
      captionShown = true;
    }
  }
  function loop() {
    computeTarget();
    current += (target - current) * 0.12;
    var t = 'translate3d(0,' + current.toFixed(2) + 'px,0)';
    for (var i = 0; i < imgs.length; i++) { imgs[i].style.transform = t; }
    if (inView || Math.abs(target - current) > 0.3) {
      window.requestAnimationFrame(loop);
    } else {
      running = false;
    }
  }
  function start() {
    if (!running) { running = true; window.requestAnimationFrame(loop); }
  }
  window.addEventListener('scroll', start, { passive: true });
  window.addEventListener('resize', start, { passive: true });
  start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-menu"] && !Shopify.designMode) return;
  try {
    
(function () {
  var menu = document.querySelector('[data-editorial-menu]');
  if (!menu) return;

  var links = Array.prototype.slice.call(menu.querySelectorAll('[data-menu-link]'));
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Smooth scroll for in-page anchor links.
  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var id = link.getAttribute('data-menu-link');
      var target = id && document.getElementById(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (window.history && history.replaceState) {
          history.replaceState(null, '', '#' + id);
        }
      }
    });
  });

  // Scroll-spy: highlight the section crossing the viewport middle.
  if ('IntersectionObserver' in window) {
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var id = entry.target.id;
          links.forEach(function (l) {
            l.classList.toggle('is-active', l.getAttribute('data-menu-link') === id);
          });
        }
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

    links.forEach(function (l) {
      var t = document.getElementById(l.getAttribute('data-menu-link'));
      if (t) spy.observe(t);
    });
  }

  // Adaptive contrast: match the menu color to the section behind it.
  var themed = Array.prototype.slice.call(document.querySelectorAll('[data-menu-theme]'));
  if (themed.length) {
    var themeTicking = false;

    function applyTheme() {
      themeTicking = false;
      var mr = menu.getBoundingClientRect();
      var y = mr.top + mr.height / 2;   // vertical centre of the menu
      var onDark = false;
      for (var i = 0; i < themed.length; i++) {
        var r = themed[i].getBoundingClientRect();
        if (r.top <= y && r.bottom > y) {
          onDark = themed[i].getAttribute('data-menu-theme') === 'dark';
          break;
        }
      }
      menu.classList.toggle('editorial-menu--on-dark', onDark);
    }

    function onThemeScroll() {
      if (!themeTicking) {
        window.requestAnimationFrame(applyTheme);
        themeTicking = true;
      }
    }

    window.addEventListener('scroll', onThemeScroll, { passive: true });
    window.addEventListener('resize', onThemeScroll, { passive: true });
    applyTheme();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-hero-slideshow]');
    if (!root) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var current = 0;
    var timer = null;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduce;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;

    function show(index) {
      index = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      current = index;
    }

    function next() {
      show(current + 1);
    }
    function prev() {
      show(current - 1);
    }

    function start() {
      if (!autoplay) return;
      stop();
      timer = window.setInterval(next, interval);
    }
    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }
    function restart() {
      stop();
      start();
    }

    if (nextBtn)
      nextBtn.addEventListener('click', function () {
        next();
        restart();
      });
    if (prevBtn)
      prevBtn.addEventListener('click', function () {
        prev();
        restart();
      });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-dot'), 10));
        restart();
      });
    });

    // Keyboard arrows when the carousel has focus within.
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        next();
        restart();
      } else if (e.key === 'ArrowLeft') {
        prev();
        restart();
      }
    });

    // Pause on hover / focus / when tab hidden.
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    // Touch swipe.
    var startX = null;
    root.addEventListener(
      'touchstart',
      function (e) {
        startX = e.touches[0].clientX;
      },
      { passive: true }
    );
    root.addEventListener(
      'touchend',
      function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) {
          if (dx < 0) {
            next();
          } else {
            prev();
          }
          restart();
        }
        startX = null;
      },
      { passive: true }
    );

    start();
  })();

  } catch(e) { console.error(e); }
})();
})();
